// extracted by mini-css-extract-plugin
export default {"panel":"Message_panel__aidp3","error":"Message_error__WMKav","dismissButton":"Message_dismissButton__o9QvJ"};